import React from "react";
import GAQCTemplateContainer from "../../modules/GAQCTemplate/containers/GAQCTemplateContainer/GAQCTemplateContainer";

const GAQCTemplate = () => {
  return <GAQCTemplateContainer />;
};

export default GAQCTemplate;
